import {NgModule} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {CommonModule} from "@angular/common";
import {PhoneLabelComponent} from "./phone-label.component";

@NgModule({
    declarations: [
        PhoneLabelComponent,
    ],
    exports: [
        PhoneLabelComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
    ]
})
export class PhoneLabelModule {}
